type AuthFlowStatus = { status: 'success' | 'ignored' };

type LoginFlowDependencies = {
  getIsLoading: () => boolean;
  setIsLoading: (value: boolean) => void;
  authenticate: () => Promise<unknown>;
  clearPrivateCaches: () => Promise<unknown>;
  refreshSession: () => Promise<unknown>;
  onSuccess?: () => Promise<unknown> | unknown;
  redirect: () => Promise<unknown> | unknown;
};

type LogoutFlowDependencies = {
  clearSession: () => Promise<unknown>;
  clearPrivateCaches: () => Promise<unknown>;
  redirect: () => Promise<unknown> | unknown;
};

export async function runLoginFlow(dependencies: LoginFlowDependencies): Promise<AuthFlowStatus> {
  if (dependencies.getIsLoading()) {
    return { status: 'ignored' };
  }

  dependencies.setIsLoading(true);

  try {
    const response = await dependencies.authenticate();
    if (!response) {
      throw new Error('Login failed');
    }

    await dependencies.clearPrivateCaches();
    await dependencies.refreshSession();
    await dependencies.onSuccess?.();
    await dependencies.redirect();

    return { status: 'success' };
  } finally {
    dependencies.setIsLoading(false);
  }
}

export async function runLogoutFlow(dependencies: LogoutFlowDependencies): Promise<AuthFlowStatus> {
  await dependencies.clearSession();
  await dependencies.clearPrivateCaches();
  await dependencies.redirect();

  return { status: 'success' };
}
